var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Connect 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Connect-24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "abb_connect_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("g", {
    id: "Final_icons_-_Common",
    transform: "translate(1.000000, 1.000000)",
    fill: "#024B9D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.39,11.62 C1.78535412,13.2895811 1.53709261,15.8425369 2.79,17.79 L0.29,20.29 L1.71,21.71 L4.21,19.21 C6.14630608,20.4950548 8.71709736,20.2533921 10.38,18.63 L14,15 L7,8 L3.39,11.62 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.71,1.71 L20.29,0.29 L17.77,2.81 C15.8358345,1.53039832 13.2713264,1.77186174 11.61,3.39 L8,7 L15,14 L18.6,10.4 C20.235544,8.73974028 20.481855,6.15973633 19.19,4.22 L21.71,1.71 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.557a96d5a73c0f8bb6a0b041dcb31c18.svg";
export { ForwardRef as ReactComponent };